export const EmptyTableDisplay = () => {
  return (
    <div className="empty-table-display--container flex-container justify-content--center align-items--center">
      <div className="">No data to display...</div>
    </div>
  );
};
